import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type InsuranceBlockContainerClasses =
  | 'root'
  | 'container'
  | 'financeContainer'
  | 'sectionTitle'
  | 'button'
  | 'financeButton'
  | 'actionsContainer'
  | 'actionButton'
  | 'actionButtonText';

const insuranceBlockContainerStyles = makeStyles<ISpcTheme, InsuranceBlockContainerClasses>(
  ({ palette, typography }) => ({
    root: {
      paddingTop: 'unset',
      paddingBottom: 'unset',
      '&:first-child': {
        paddingTop: 'unset',
      },
    },
    container: {
      textAlign: 'center',
      border: `1px solid ${palette.primary.light}`,
      padding: '48px 15px',
    },
    financeContainer: {
      display: 'contents',
    },
    sectionTitle: {
      fontWeight: typography.fontWeightRegular,
      textTransform: 'uppercase',
      color: palette.primary.light,
    },
    button: {
      marginTop: '15px',
      height: '40px',
      borderRadius: 'unset',
      padding: '10px',
      backgroundColor: palette.primary.light,
    },
    financeButton: {
      margin: 'auto',
      height: '40px',
      borderRadius: 'unset',
      padding: '10px',
      width: '200px',
    },
    actionsContainer: {
      justifyContent: 'center',
    },
    actionButton: {
      height: '40px',
      maxWidth: '250px',
      fontWeight: typography.fontWeightRegular,
    },
    actionButtonText: {
      fontSize: typography.fontMD,
    },
  }),
  { name: 'Customise_InsuranceBlockContainer' },
);

export default insuranceBlockContainerStyles;
